//NEW: UI_REVAMP
import { Button, Circle, Flex, Grid, GridItem, Input, Text, useDisclosure } from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import { useBettingScreen } from '../../hooks/useStore';
import ImgComp from '../../utils/ImgComp';
import { currencyFormat } from '../../utils/numberFormat';
import PriceText from '../betting/PriceText';
import GoldPatternButton from '../button/GoldPatternButton';
import GlassModal from '../modal/GlassModal';

const EnterPriceKeypad = ({ activeBetTab, onClick, onClose, isDisabled }) => {
	const { isOpen, onOpen, onClose: onCloseDeleteModal } = useDisclosure();

	const [selectedPrice, setSelectedPrice] = useState('');
	const prices = ['10', '20', '30', '60', '100', '200', '300', '400'];

	const allBetting = useBettingScreen((state) => state.betting);
	const updateAllBetPrices = useBettingScreen((state) => state.updateAllBetPrices);
	const removeAll = useBettingScreen((state) => state.removeAll);

	const totalPrice = useMemo(() => {
		return allBetting.reduce((acc, bet) => acc + (Number(bet.betPrice) || 0), 0);
	}, [allBetting]);

	const handlePriceClick = (price) => {
		setSelectedPrice(price);
		updateAllBetPrices(Number(price));
	};

	const handleInputChange = (e) => {
		const numericValue = e.target.value.replace(/[^0-9]/g, '').slice(0, 16);
		setSelectedPrice(numericValue);
		updateAllBetPrices(numericValue === '' ? '' : Number(numericValue));
	};

	const handleDeleteAll = () => {
		removeAll();
		onCloseDeleteModal();
		if (onClose) onClose();

		setSelectedPrice('');
	};

	let value;
	if (isDisabled) {
		value = '';
	} else {
		value = selectedPrice ? currencyFormat(Number(selectedPrice)) : '';
	}

	return (
		<>
			<Input
				placeholder='Enter Bet Price'
				value={value}
				onChange={handleInputChange}
				isReadOnly={isDisabled}
				mb={2}
				bg='white'
				fontSize='14px'
				fontWeight={400}
				py={3}
				px={2.5}
				maxLength={11} //including comma
				border='1px solid #DEDEDE'
				_placeholder={{ color: isDisabled ? '#BDBDBD' : '#666666' }}
				_focus={{ ring: 0, border: '1px solid #DEDEDE' }}
				_hover={{}}
			/>

			<Grid className='numbers-container' templateColumns='repeat(4, 1fr)' gap={1} mb={2}>
				{prices.map((price) => {
					const isSelected = selectedPrice === price;

					let bg;
					let boxShadow;
					let color;

					if (isDisabled) {
						bg = '#DAD4FF';
						boxShadow = 'none';
						color = '#AFA2FE';
					} else if (isSelected) {
						bg = 'linear-gradient(180deg, #FCE007 0%, #F99D20 100%)';
						boxShadow = '';
						color = '#111';
					} else {
						bg = '#8774FE';
						boxShadow = '0 -2px 5px 0 #D0DDEB inset';
						color = 'white';
					}
					return (
						<GridItem key={price}>
							<Button
								isDisabled={isDisabled}
								bg={bg}
								boxShadow={boxShadow}
								color={color}
								py={2}
								px={1}
								_hover={{ bg, boxShadow, color }}
								onClick={() => {
									handlePriceClick(price);
								}}
								w='full'
							>
								<PriceText
									color='inherit'
									priceFontSize='16px'
									currencyFontSize='12px'
									price={price}
								/>
							</Button>
						</GridItem>
					);
				})}
			</Grid>

			<Flex alignItems='center' gap={2}>
				<Button
					onClick={() => {
						onOpen();
					}}
					isDisabled={isDisabled}
					display='flex'
					alignItems='center'
					bg='transparent'
					_hover={{ bg: 'transparent' }}
					opacity={isDisabled ? '0.5 !important' : 1}
				>
					<ImgComp svgName='delete-all' h={6} w={6} />
					<Text decoration='underline' color='#D7212C' textTransform='capitalize'>
						Delete All
					</Text>
				</Button>
				<GoldPatternButton onClick={onClick} isDisabled={isDisabled}>
					<Flex alignItems='center' justifyContent='space-between' w='full'>
						<Flex alignItems='center' gap={1}>
							<Text as='span'>Total Bet</Text>
							<Circle
								size={6}
								bg='#D7212C'
								color={isDisabled ? 'rgba(239, 116, 132, 1)' : 'white'}
								border='1px solid #FA616B'
								fontWeight={600}
								fontSize='14px'
							>
								{allBetting.length}
							</Circle>
						</Flex>
						<Flex alignItems='center' gap={2}>
							<ImgComp svgName='coin' w={3} h={3} />
							<PriceText
								priceFontSize='22px'
								currencyFontSize='14px'
								price={totalPrice ?? 0}
								color={isDisabled ? 'rgba(233, 127, 21, 1)' : 'white'}
							/>
						</Flex>
					</Flex>
				</GoldPatternButton>
			</Flex>

			<GlassModal
				variant='alert'
				icon='clear'
				title='Delete All?'
				isOpen={isOpen}
				leftButton={{ onClick: onCloseDeleteModal }}
				rightButton={{ onClick: handleDeleteAll }}
			/>
		</>
	);
};

export default EnterPriceKeypad;
